<template>
<div class="header-style">
  <desktop-header :mainMenu="menuItems" :user="user" />
  <!-- <v-layout class="ui-header" column> -->
    <!-- <desktop-header-links /> -->
  <!-- </v-layout> -->
</div>
</template>

<style lang="scss" scoped>
// @import '../../styles/variables';

// $color: #424242;

// .ui-header {
//   background: #ffffff;

//   .header {
//     max-width: 1024px;
//     width: 100%;
//     margin: auto;
//   }

//   .provider {
//     text-align: left;
//     color: white;
//     // max-width: 200px;
//     padding: 20px 0;
//   }

//   .provider .title {
//     font-weight: bold;
//     color: $color;
//   }

//   .provider .location {
//     font-size: 12px;
//     color: $color;
//   }
// }
</style>


<script>
import DesktopHeader from '@/core/components/DesktopHeader'
import DesktopHeaderLinks from '@/components/headers/DesktopHeaderLinks'

import { mapState } from 'vuex'

export default {
  name: 'OneHeader',
  components: {
    DesktopHeader,
    DesktopHeaderLinks
  },
  props: {
    provider: {
      type: Object
    }
  },
  data() {
    return {
      menuItems: [
        {
          label: 'links.account.label',
          action: () => this.$router.push('/account')
        },
        {
          label: 'links.signout.label',
          action: () => this.$emit('signout')
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('provider', ['partner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/headers/DesktopHeader.vue